import { render, staticRenderFns } from "./VersionsPage.vue?vue&type=template&id=173b4a3c&scoped=true&"
import script from "./VersionsPage.vue?vue&type=script&lang=js&"
export * from "./VersionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173b4a3c",
  null
  
)

component.options.__file = "VersionsPage.vue"
export default component.exports